<template>
  <div v-loading="loading" class="home-block-detail">
    <action-bar>
      <el-button type="primary" @click="handleToHomeChart()">首页大屏</el-button>
      <div class="fill"></div>
      <subscribe-block></subscribe-block>
    </action-bar>
    <common-bg-plate>
      <detail-table :title="title1" :table-col="tableCol1" :list="list1"></detail-table>
      <detail-table :title="title2" :table-col="tableCol2" :list="list2"></detail-table>
      <detail-section class="tx-detail-section" title="交易信息">
        <normal-table
          v-loading="loadingTx"
          :table-data="tableData"
          :table-col="tableCol"
          :paging="paging"
          :show-edit="showEdit"
          :operator="operator"
          :operate-col="operatorCol"
          @pagination="getTxnListFn"
        ></normal-table>
      </detail-section>
    </common-bg-plate>
  </div>
</template>

<script>
import subscribeBlock from '../components/subscribeBlock'
import timeImg from '@/assets/images/tableIcon/time.png'
import hashImg from '@/assets/images/tableIcon/hash.png'
import frontHashImg from '@/assets/images/tableIcon/front-hash.png'
import readWriteHashImg from '@/assets/images/tableIcon/read-write-hash.png'
import heightImg from '@/assets/images/tableIcon/height.png'
import organizationImg from '@/assets/images/tableIcon/organization.png'
import merkelImg from '@/assets/images/tableIcon/merkel.png'
import dagFeaturesImg from '@/assets/images/tableIcon/dag-features.png'
import cdnNodeImg from '@/assets/images/tableIcon/cdn-node.png'

import { mapState, mapActions } from 'vuex'
export default {
  name: 'BlockDetail',
  components: {
    subscribeBlock
  },
  data() {
    return {
      title1: '区块基本信息',
      tableCol1: [
        { label: '区块Hash', icon: hashImg, value: 'blockHash' },
        { label: '区块高度', icon: heightImg, value: 'blockHeight' },
        { label: '前区块Hash', icon: frontHashImg, value: 'preBlockHash' },
        { label: '时间戳', icon: timeImg, value: 'createAt' }
      ],
      list1: {},
      title2: '其他信息',
      tableCol2: [
        { label: '读写集哈希', icon: readWriteHashImg, value: 'rwSetHash' },
        { label: '交易默克尔根', icon: merkelImg, value: 'txRootHash' },
        { label: 'DAG特征值', icon: dagFeaturesImg, value: 'dagHash' },
        { label: '出块组织', icon: organizationImg, value: 'OrgId' },
        { label: '出块节点', icon: cdnNodeImg, value: 'proposer_id' }
      ],
      list2: {},
      //交易信息
      showEdit: true,
      tableCol: [
        { label: '交易ID', prop: 'txId', minWidth: 339 },
        { label: '发起组织', prop: 'orgId', minWidth: 116 },
        { label: '上链时间', prop: 'createAt', minWidth: 132 },
        { label: '交易状态', prop: 'txStatusCode', minWidth: 186 },
        { label: '目标合约', prop: 'contractName', minWidth: 116 },
        { label: '发起用户', prop: 'sender', minWidth: 200 }
      ],
      loadingTx: true,
      operator: [
        {
          text: '查看',
          showText: true,
          icon: 'icon-check',
          class: 'operate-check',
          click: (row, col, cellValue) => {
            return this.goTxDetailFn(row)
          }
        }
      ],
      operatorCol: {
        minWidth: 78
      },
      // 加载中
      loading: true
    }
  },
  computed: {
    ...mapState({
      tableData: state => state.home.txn_list,
      paging: state => state.home.txn_paging
    })
  },
  watch: {
    '$store.state.home.chainCid': {
      deep: true,
      handler() {
        this.getTxnListFn()
        this.getBlockListFn()
      }
    }
  },
  mounted() {
    if (this.$store.state.home.chainCid) {
      this.getTxnListFn()
      this.getBlockListFn()
    }
  },
  methods: {
    ...mapActions(['getBlockLists', 'getTxnLists']),
    // 获取详情并赋值
    setParamsFn(params = {}) {
      this.list1 = {
        blockHash: params.blockHash,
        blockHeight: params.blockHeight,
        preBlockHash: params.preBlockHash,
        createAt: params.createAt
      }
      this.list2 = {
        rwSetHash: params.rwSetHash,
        txRootHash: params.txRootHash,
        dagHash: params.dagHash,
        OrgId: params.OrgId,
        proposer_id: params.proposer_id
      }
    },
    // 查询区块信息
    getBlockListFn(limit = 10, offset = 0) {
      let params = {
        offset,
        limit,
        chainId: this.$store.state.home.chainCid,
        height: this.$route.query.blockHeight
      }
      this.getBlockLists(params).then(res => {
        this.setParamsFn(res.items[0])
        this.loading = false
      })
    },
    // 获取交易列表

    getTxnListFn(params = {}) {
      params.offset = params.offset * this.paging.limit || 0
      params.limit = params.limit || 10
      ;(params.chainId = this.$store.state.home.chainCid),
        (params.height = parseInt(this.$route.query.blockHeight) || 0)

      this.getTxnLists(params)
        .then(res => {
          this.loadingTx = false
        })
        .catch(err => {
          this.loadingTx = false
        })
    },

    goTxDetailFn(row) {
      this.$router.push({
        name: 'txnDetail',
        query: {
          txId: row.txId
        }
      })
    },
    handleToHomeChart() {
      this.$router.push('../dataAnalysis')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'home-block-detail',
  (
    --home-block-detail-operate-check-color: #45c2ff
  ),
  (
    --home-block-detail-operate-check-color: #45c2ff
  )
);
.home-block-detail {
  @include adaptation(
    (
      --home-block-detail-tx-list-item-height: 64px,
      --home-tx-detail-unavailable-height: 662px,
      --home-block-detail-item-height: 70px
    )
  );
  --home-tx-detail-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--home-tx-detail-unavailable-height)
  );

  .cbaas-detail-table {
    /deep/ {
      .detail-item {
        height: var(--home-block-detail-item-height);
      }
    }
  }
  .tx-detail-section {
    padding-bottom: 0;

    /deep/ .content {
      padding-bottom: 0;
    }
  }

  .normal-table-wrap {
    min-height: var(--home-tx-detail-min-height);
    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--home-tx-detail-min-height);
      }

      .normal-table {
        min-height: var(--home-tx-detail-min-height);
        .el-table {
          .el-table__body {
            tr {
              height: var(--home-block-detail-tx-list-item-height);
            }
          }
          .el-table__cell {
            .cell {
              height: auto;
              white-space: normal;

              .operate-item {
                &.operate-check {
                  color: var(--home-block-detail-operate-check-color);
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
